import { createContext } from 'react';

/** Production auth ownership is established above the route tree. */
export const FitnessWorkoutRuntimeManaged = createContext(false);
